import React from 'react';
import LevelSelect from './LevelSelect';
import './HowToPlayModal.css';

interface LevelModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedLevel: 4 | 6 | 8;
  onLevelChange: (level: 4 | 6 | 8) => void;
}

const LevelModal: React.FC<LevelModalProps> = ({ isOpen, onClose, selectedLevel, onLevelChange }) => {
  if (!isOpen) return null;

  return (
    <div className="how-to-play-overlay" onClick={onClose}>
      <div className="how-to-play-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>

        <h2>Select Level</h2>

        <div className="modal-section" style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '2rem', color: '#ccc' }}>
            Choose your preferred grid size. Each level has its own leaderboard.
          </p>

          <LevelSelect
            selectedLevel={selectedLevel}
            onLevelChange={(level) => {
              onLevelChange(level);
              onClose();
            }}
          />

          <p style={{ marginTop: '2rem', fontSize: '0.9em', color: '#888' }}>
            Changing the level will restart the game.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LevelModal;
